/**
 * Wann eine Seite den Ladezustand zeigen darf - und wann sie stillhalten muss.
 *
 * BEFUND 31.07.2026 (echter Durchlauf, Antoine): Waehrend „Ihr Angebot entsteht" lief, sprang die
 * Anfragen-Liste dahinter im Sekundentakt zwischen Ladebalken und Inhalt. Ursache war kein Fehler
 * im Popup, sondern das Zusammentreffen zweier fuer sich richtiger Dinge: Das Fortschritts-Popup
 * pollt alle 700 ms (`pages/inquiries.tsx`), und `useApi` schaltete bei JEDEM Durchlauf `loading`
 * wieder ein — auch wenn die Daten laengst dastanden.
 *
 * Die Unterscheidung, die gefehlt hat: Ein ERSTES Laden hat nichts zu zeigen, da gehoert der
 * Ladezustand hin. Ein NACHladen desselben Pfades hat bereits Inhalt — der bleibt stehen, bis die
 * neuen Daten da sind. Ein PFADwechsel zaehlt wieder als erstes Laden, sonst zeigt die Seite kurz
 * die Daten des alten Pfades unter der neuen Ueberschrift.
 *
 * Eigene Datei, damit sie ohne die Stack-Auth-Kette pruefbar ist: `useApi` importiert `lib/api`,
 * das beim Laden bereits eine Stack-App baut und ohne Projekt-Id wirft. Der erste Anlauf des Tests
 * scheiterte genau daran — also aus dem falschen Grund, und ein Test, der aus dem falschen Grund
 * rot ist, beweist nichts.
 */

/**
 * @param vorherigerPfad zuletzt geladener Pfad (null = es wurde noch nie geladen)
 * @param neuerPfad Pfad, der jetzt geladen wird
 * @param hatDaten liegen bereits Daten vor?
 */
export function zeigtLadezustand(vorherigerPfad: string | null, neuerPfad: string, hatDaten: boolean): boolean {
  if (vorherigerPfad !== neuerPfad) return true; // erstes Laden oder Pfadwechsel
  return !hatDaten; // gleicher Pfad: nur wenn wirklich nichts dasteht (z. B. nach einem Fehler)
}
